import { motion } from 'framer-motion';
export default function CompanyTrust() {
  const services = [
    {
      icon: '/securityservice.png',
      title: 'Security Services',
      link: '/building-maintenance',
      desc: 'Comprehensive, professional security solutions tailored to businesses across the UK.',
    },
    {
      icon: '/dataprivacy.png',
      title: 'Data Privacy',
      link: '/building-maintenance',
      desc: 'We treat your information as carefully as we protect your premises. ',
    },
    {
      icon: '/industrycertified.png',
      title: 'Industry Certified',
      link: '/Integrated Security',
      desc: 'Our officers and processes meet recognised UK industry standards. ',
    },
  ];
  return (
    <motion.div
      initial={{ opacity: 0, y: 80 }} // start lower
      whileInView={{ opacity: 1, y: 0 }} // animate to normal
      viewport={{ once: true, amount: 0.5 }} // trigger when 50% visible
      transition={{ duration: 0.8, ease: 'easeOut' }}
      className="relative z-[4444] mb-[4rem] mt-[-20vh] flex w-full justify-center py-[2.5rem] font-inter"
    >
      {' '}
      <div className="flex w-full max-w-[114rem] flex-col items-stretch justify-center gap-[4rem] px-[2rem]">
        <div className="grid w-full grid-cols-1 gap-[1rem] sm:grid-cols-2 md:grid-cols-2 md:gap-[2rem] lg:grid-cols-3 lg:gap-[6rem]">
          {services.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-start gap-3 rounded-xl bg-[#011936] px-[4rem] py-[3rem] text-center transition"
            >
              <div className="flex w-full items-center justify-start gap-[2rem]">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="aspect-1 w-[3.5rem] object-cover"
                />
                <h3 className="py-[1rem] text-[1.8rem] font-[600] leading-[2.7rem] text-white">
                  {item.title}
                </h3>
              </div>
              <p className="mt-[1rem] text-start text-[1.6rem] font-[400] leading-[2.4rem] text-[#828FA0]">
                {item.desc}
              </p>
              {/* <div
                  onClick={() => {
                    navigate(item.link);
                  }}
                  className="mt-[2rem] flex w-full cursor-pointer items-center justify-center gap-[1rem] text-[#0EC9AC]"
                >
                  <h1 className="text-[1.2rem] font-[600] leading-[100%]">READ MORE</h1>
                  <ArrowRight className="h-auto w-[1.6rem] text-[1.2rem]" />
                </div> */}
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
